var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.504395,
    width: 52.2523,
    height: 52.2523,
    rx: 26.1261,
    fill: "#D4EAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1306 31.126C16.432 27.8292 16.432 24.4227 17.1306 21.126C17.2224 20.7912 17.3998 20.4861 17.6452 20.2406C17.8907 19.9951 18.1958 19.8178 18.5306 19.726C23.8941 18.8374 29.3672 18.8374 34.7306 19.726C35.0654 19.8178 35.3705 19.9951 35.616 20.2406C35.8615 20.4861 36.0388 20.7912 36.1306 21.126C36.8292 24.4227 36.8292 27.8292 36.1306 31.126C36.0388 31.4608 35.8615 31.7659 35.616 32.0114C35.3705 32.2568 35.0654 32.4342 34.7306 32.526C29.3672 33.4147 23.8941 33.4147 18.5306 32.526C18.1958 32.4342 17.8907 32.2568 17.6452 32.0114C17.3998 31.7659 17.2224 31.4608 17.1306 31.126Z",
    stroke: "#0071DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6306 29.126L29.6306 26.126L24.6306 23.126V29.126Z",
    stroke: "#0071DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/yt.e93c17a349ff48f8d0af1c219e82aebd.svg";
export { ForwardRef as ReactComponent };